// extracted by mini-css-extract-plugin
export default {"card":"Z7-z"};